import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  tag: {
    backgroundColor: "#EDF5FB",
    borderRadius: 4,
    height: 28,
    padding: "4px 8px",
    font: "600 12px/20px Manrope !important",
    color: "#308CDB !important",
  },
  wrapper: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },
  p08: {
    padding: "0 8px",
  },
  militarySectionTitle: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 0,
    paddingTop: 16,
    paddingBottom: 24,
    color: "#465869",
  },
  preApprovalTableContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    border: "1px solid #e4e7ec",
    borderRadius: 8,
    backgroundColor: "#F7F7F9",
    boxSizing: "border-box",
    marginBottom: 16,
  },
  preApprovalGridRowView: {
    display: "grid",
    gridTemplateColumns:
      "minmax(56px, 0.95fr) minmax(96px, 2fr) minmax(44px, 0.7fr) minmax(44px, 0.7fr) minmax(80px, 1.1fr) minmax(56px, 0.9fr) minmax(56px, 0.9fr)",
    columnGap: 4,
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  preApprovalTable: {
    width: "100%",
    minWidth: 0,
  },
  preApprovalHeadRow: {
    height: 32,
    backgroundColor: "#fcfcfd",
    boxShadow: "inset 0px -1.5px 0px #d2e2f0",
  },
  preApprovalHeadCell: {
    backgroundColor: "#fcfcfd",
    fontFamily: "Manrope",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 900,
    lineHeight: "16px",
    letterSpacing: "0em",
    textTransform: "uppercase",
    color: "rgb(29, 41, 57)",
    padding: "5px",
    paddingTop: 0,
    paddingBottom: 0,
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  preApprovalBodyRowZebra: {
    backgroundColor: "#f2f4f7",
  },
  preApprovalBodyRowPlain: {
    backgroundColor: "#fff",
  },
  preApprovalBodyCell: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    fontFamily: "Manrope",
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0em",
    color: "#667085",
    padding: "4px 0px 4px 4px",
    wordBreak: "break-word",
  },
}));

export default styles;
